import { getCountryCodeFromAff } from "./getCountryFlag";

// Get country name based on country code
export const getCountryNameFromCode = (code: string, locale: string) => {
  try {
    const displayNames = new Intl.DisplayNames(locale, { type: "region" });
    return displayNames.of(code);
  } catch (error) {
    console.warn("Invalid Country Code", code);
  }
  return code;
};

export const getCountryNameFromAff = (aff: string, locale: string) => {
  const countryCode = getCountryCodeFromAff(aff.padStart(3, "0"));
  return getCountryNameFromCode(countryCode, locale);
};
